export const ID_TOKEN: string = 'cognito-id-token';
export const ACCESS_TOKEN: string = 'cognito-access-token';
export const LOGGED_IN: string = 'cognito-loggedin-email';
export const REG_USER_TYPE: string = 'registered-user-type';
export const CURRENT_USER: string = 'current-user-profile';
export const FEDERATED_SERVICE_ID: string = 'federated-service-id';
export const FEDERATED_TOKENS: string = 'federated-token';
export const FEDERATED_TOKENS_INITIAL: string = 'federated-tokens-initial';
export const FEDERATED_ACTION: string = 'federated-action';
export const FEDERATED_ERROR_ACTION: string = 'federated-error-action';
export const FEDERATED_QUERY_PARAMS: string = 'federated-query-params';
export const FEDERATED_ERROR_QUERY_PARAMS: string = 'federated-error-query-params';
